import * as React from 'react';
import Image from 'next/image';
import { ReactNode } from 'react';

import { customImageLoader, getAssetSrc, cn } from '@restworld/utils-common';

/* eslint-disable-next-line */
export interface NotFoundProps {
  mainTitle?: string;
  subTitle?: string;
  buttonTitle?: string;
  callback?: () => void;
  ctaButtons?: ReactNode;
  wrapperStyles?: string;
}

const Wrapper = ({ wrapperStyles, className, ...props }: any) => (
  <div
    className={cn('flex flex-col gap-6 items-center justify-center h-full w-full', wrapperStyles, className)}
    {...props}
  />
);

export function NotFound({ mainTitle, subTitle, ctaButtons, wrapperStyles }: NotFoundProps) {
  return (
    <Wrapper wrapperStyles={wrapperStyles}>
      <Image
        src={getAssetSrc('/utils-assets/not-found.svg')}
        width={238}
        height={220}
        loader={customImageLoader}
        alt="not-found"
      />
      {!!mainTitle && (
        <h5 className="self-stretch text-center justify-start text-neutral-700 text-base font-semibold">{mainTitle}</h5>
      )}
      {!!subTitle && (
        <h5 className="self-stretch text-center justify-start text-neutral-200 text-base font-medium">{subTitle}</h5>
      )}
      {ctaButtons}
    </Wrapper>
  );
}

export default NotFound;
